// A team invitation opened while signed out is parked here so the app
// shell can resume it after login / signup (see _app.tsx beforeLoad).
export const TEAM_INVITE_KEY = "lucy.web.team_invite"

export function stashInvite(token: string) {
  try { sessionStorage.setItem(TEAM_INVITE_KEY, token) } catch { /* private mode */ }
}

export function clearInvite() {
  try { sessionStorage.removeItem(TEAM_INVITE_KEY) } catch { /* private mode */ }
}
